import { useEffect } from 'react'
import { QUERIES } from '../constants/routes'
import { useLazyGetPointQuery } from '../store'
import { useActions } from './redux/actions'
import { useInitialQuery } from './useInitialQuery'

export const useInitialSelectedPoint = () => {
  const initialQuery = useInitialQuery()
  const [fetchPoint] = useLazyGetPointQuery()
  const { setSelectedPoint, setSelectedPointId } = useActions()

  useEffect(() => {
    const pointId = Number(initialQuery.get(QUERIES.POINT_ID))
    initialQuery.delete(QUERIES.POINT_ID)

    if (pointId) {
      fetchPoint(pointId)
        .unwrap()
        .then((value) => {
          if (value?.length > 0) {
            setSelectedPoint(value[0])
            setSelectedPointId(value[0].id)
          }
        })
    }
  }, [initialQuery, fetchPoint, setSelectedPoint, setSelectedPointId])
}
